module.exports = __webpack_public_path__ + "img/banner.e0ea2c4e.jpg";